import { render, staticRenderFns } from "./ShiftsCounter.vue?vue&type=template&id=ebb2d48c&scoped=true&"
import script from "./ShiftsCounter.vue?vue&type=script&lang=js&"
export * from "./ShiftsCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb2d48c",
  null
  
)

export default component.exports